import { Button } from 'blaze-ui/Button'
import { SelectAvatarButtonProps } from 'components/SecretIdentity/Types'
import { useSelectAvatarButton } from 'components/SecretIdentity/useSelectAvatarButton'

export const SelectAvatarButton = ({ children = 'Select Avatar', size }: SelectAvatarButtonProps) => {
  const { buttonProps } = useSelectAvatarButton()

  return (
    <Button {...buttonProps} size={size}>
      {children}
    </Button>
  )
}
